/**
 * Format a billing amount for display.
 * @param {number|string} amount
 * @param {string} currency - usd | eur | deepdocs_unit
 */
export function formatBillingAmount(amount, currency) {
  const value = Number(amount)
  if (!Number.isFinite(value)) return "—"
  const neg = value < 0
  const abs = Math.abs(value)
  let formatted
  switch (currency) {
    case "usd":
      formatted = `$${abs.toFixed(2)}`
      break
    case "eur":
      formatted = `€${abs.toFixed(2)}`
      break
    case "deepdocs_unit":
      formatted = `${Math.round(abs).toLocaleString()} Units`
      break
    default:
      formatted = `${abs} ${currency || ""}`.trim()
  }
  return neg ? `-${formatted}` : formatted
}

/**
 * Pick the primary balance row for display.
 * @param {{ primary_currency?: string, balances?: Array<{currency:string,balance:number,formatted?:string}> }} payload
 */
export function pickPrimaryBalance(payload) {
  if (!payload) return null
  const currency = payload.primary_currency || "deepdocs_unit"
  const rows = Array.isArray(payload.balances) ? payload.balances : []
  const row = rows.find((b) => b.currency === currency) || rows[0]
  if (!row) {
    return {
      currency,
      balance: 0,
      formatted: formatBillingAmount(0, currency),
    }
  }
  return {
    currency: row.currency,
    balance: Number(row.balance) || 0,
    formatted: row.formatted || formatBillingAmount(row.balance, row.currency),
  }
}
